// extracted by mini-css-extract-plugin
module.exports = {"product-card":"styles-module__product-card___3MHHo","product-image":"styles-module__product-image___QKciz"};